import React from 'react';
import { Route } from 'react-router-dom';

import EntregaFornecedorFicha from '../../Logistica/entregaFornecedor/dadosGerais/components/dadosGerais';
import EntregaFornecedorDestaques from '../../Logistica/entregaFornecedor/destaque/EntregaFornecedorDestaque';
import EntregaFornecedorIndex from '../../Logistica/entregaFornecedor/listagem/EntregaFornecedorIndex';

const LogisticaRoutes = () => {
  return (
    <>
      {/* Entregas Fornecedores */}
      <Route path="logistica/fornecedor" element={<EntregaFornecedorIndex />} />
      <Route
        path="logistica/fornecedor/ficha/destaques"
        element={<EntregaFornecedorDestaques />}
      />
      <Route
        path="logistica/fornecedor/ficha/:id/destaques"
        element={<EntregaFornecedorDestaques />}
      />
      <Route
        path="logistica/fornecedor/ficha/dadosgerais"
        element={<EntregaFornecedorFicha />}
      />
      <Route
        path="logistica/fornecedor/ficha/:id/dadosgerais"
        element={<EntregaFornecedorFicha />}
      />
    </>
  );
};

export default LogisticaRoutes;
